import React, { useState, useEffect } from "react";
import Menu from "../Menu";

function HeroSectionPartner({ onCtaClick }) {
    // Use the same assets logic
    let heroImage = "/assets/images/hero_partnership.webp";
    let vectorIcon = "/assets/images/ico_start_arrow.svg";

    const [paddingTop, setPaddingTop] = useState(0);

    // EXACT same calculation logic from HeroSection.js but adjusted for bottom alignment
    const calculatePadding = () => {
        const herotitle = document.querySelector(".herotitle");
        const herotitleSub = document.querySelector(".herotitleSub");
        const ctaIntro = document.querySelector(".cta-intro");

        if (ctaIntro) {
            const totalHeight =
                (herotitle?.offsetHeight || 0) +
                (herotitleSub?.offsetHeight || 0) +
                (ctaIntro?.offsetHeight || 0);

            const viewportHeight = window.innerHeight;
            // Push text to the bottom (leaving offset for footer/divider)
            const calculatedPadding = viewportHeight - totalHeight - 150;
            setPaddingTop(calculatedPadding);
        }
    };

    useEffect(() => {
        // Standardize GTM tracking logic
        const navLinks = document.querySelectorAll(".bg-body-tertiary .nav-link");
        navLinks.forEach((link) => {
            link.classList.add("gtm-lp", "gtm-nav-link");
        });

        calculatePadding();
        window.addEventListener("resize", calculatePadding);
        return () => {
            window.removeEventListener("resize", calculatePadding);
        };
    }, []);

    return (
        <>
            <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1002 }}>
                <Menu />
            </div>
            <div className="heroSection hero-section-partner">
                <div className="fCorLeft hero-fcorleft"></div>

                {/* Subtle Dark Overlay for Partnership readability */}
                <div className="hero-overlay"></div>

                <div
                    className="herotitleCont hero-title-cont"
                    style={{
                        paddingTop: paddingTop > 0 ? `${paddingTop}px` : '40vh'
                    }}
                >
                    <h1 className="herotitle">
                        Your Content.<br />
                        <span className="text-brand-red">Our Platform.</span>
                    </h1>
                    <h5 className="herotitleSub hero-subtitle">
                        Reach millions of viewers on all major CTV and mobile<br />
                        platforms — and earn revenue from your films, shows, and videos.
                    </h5>

                    <p className="cta-intro hero-cta-intro">
                        <a
                            className="btn btn-primary hero-cta-button gtm-lp gtm-browse-now"
                            onClick={onCtaClick}
                        >
                            Get Started
                            <img
                                src={vectorIcon}
                                className="img-fluid hero-cta-icon"
                                alt="icon"
                            />
                        </a>
                    </p>
                </div>

                {/* DIVFOOTER*/}
                <div className="partnership-footer-divider">
                    <img
                        src="/assets/images/divfooter.svg"
                        alt=""
                        className="img-fluid"
                    />
                </div>
            </div>


            <div className="heropicCont hero-pic-cont">
                <img src={heroImage} className="heropic hero-pic" alt="fawesome partnership" />
            </div>
        </>
    );
}

export default HeroSectionPartner;